import axios from 'axios';

import type {
	adflowApiSchema,
	JoinPaths,
} from '@adflow/shared/util-route-schema';
import { makeRequester } from '@adflow/shared/util-route-schema';

export const apiRequest = makeRequester<{
	pathPattern: JoinPaths<typeof adflowApiSchema.pathPatternPrefix, string>;
}>(axios);
